import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'

const state = {
  account: {

  },
  accounts: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['description'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.account = {
      companyId: store.get('authStore@currentCompany').id,
      bankAccountType: 'CHECKING',
    }
    state.type = 'add'
    state.dialog = true
  },

  edit: ({ state }, id) => {
    state.loading = true
    store.dispatch('accountStore/getById', id)
      .then(res => {
        state.account = { ...res.data, bankAccountType: res.data.bankAccountType || 'CHECKING' }

        state.type = 'edit'
        state.dialog = true
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  save: ({ state }, account) => {
    const id = account.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/account/${id || ''}`, account)
      .then((res) => {
        state.dialog = false
        store.dispatch('accountStore/get')
        showSuccess('Conta financeira salva com sucesso!')
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/account?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.accounts = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },

  getById: (_, id) => axios.get(`${process.env.VUE_APP_API_URL}/account/${id}`).catch(showError),

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/account/${id}`)
      .then(_ => {
        store.dispatch('accountStore/get')
        showSuccess('Conta excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => {
        state.loading = false
      })
  },
}
const getters = {
  getById: state => id => {
    return state.accounts.data.find((u) => String(u.id) === String(id))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
